import { api } from './api'

export const checkout = {
    remove_alert() {
        let elem = document.getElementById('input-login_error');
        if (typeof (elem) != 'undefined' && elem != null) {
            elem.remove();
        }
    },
    async login(e, p) {
        this.remove_alert();
        const response = await api.post(
            'quickcheckout/checkout/checkout_login',
            `email=${e}&password=${p}`
        )
        if (response.error) {
            let data = document.createElement('span');
            data.id = 'input-login_error';
            data.className += ' text-red-500 text-base';
            data.innerHTML = response.error;
            let div = document.getElementById('input-login_email');
            div.parentNode.insertBefore(data, div.nextSibling);
            return;
        }
        location.href = response.redirect.replace(/&amp;/g, '&');
    }
}